<div class="sp-row__space">
  <div class="sp-row__align">
    <mat-icon
      class="sp-color__primary sp-hidden__before-md sp-cursor__pointer"
      (click)="onBackClick()">
      arrow_back
    </mat-icon>
    <h2 class="sp-margin__left sp-color__primary sp-hidden__before-md">{{ getShrinkedID() }}</h2>
    <h3 class="sp-margin__left sp-color__primary sp-hidden__after-md">{{ getShrinkedID() }}</h3>
  </div>

  <div class="sp-row__align">
    <mat-spinner
      *ngIf="is_read_running"
      color="accent"
      diameter="20"></mat-spinner>

    <app-store-details-navbar
      *ngIf="!is_read_running"
      (tab_change)="tab_change.emit($event)"></app-store-details-navbar>

    <button
      (click)="$event.stopPropagation()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent sp-margin__left"
      [matTooltip]="'Menu' | translate"
      [mat-menu-trigger-for]="stores_details_actions_menu">
      <mat-icon> more_horiz </mat-icon>
    </button>

    <mat-menu #stores_details_actions_menu="matMenu">
      <button
        (click)="onTicketClick(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> euro </mat-icon>
        <span> {{ 'STORES.TICKET_CTA' | translate }} </span>
      </button>

      <button
        (click)="onEnableDisableClick(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> do_not_disturb_on </mat-icon>
        <span> {{ 'STORES.ENABLE_DISABLE_CTA' | translate }} </span>
      </button>

      <button
        (click)="onStoreQineticPsClick(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> account_balance </mat-icon>
        <span> {{ 'STORES.QINETIC_PS_DIALOG_CTA' | translate }} </span>
      </button>

      <button
        (click)="onAllowedStepsClick(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> apps</mat-icon>
        <span> {{ 'STORES.ALLOWED_STEPS_LABEL' | translate }} </span>
      </button>

      <button
        (click)="onQrCodeClick(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> qr_code </mat-icon>
        <span> QR code </span>
      </button>

      <button
        (click)="onPluginCredentialsClick(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> extension </mat-icon>
        <span> {{ 'STORES.SET_PLUGIN_CREDENTIALS_DIALOG_CTA' | translate }} </span>
      </button>
    </mat-menu>

    <button
      (click)="refresh.emit()"
      mat-icon-button
      [matTooltip]="'GENERAL.REFRESH_CTA' | translate"
      class="sp-icon__button sp-icon__button-dark sp-margin__left">
      <mat-icon class="material-symbols-outlined"> refresh </mat-icon>
    </button>
  </div>
</div>
